import { AGREEMENT } from 'core/datasets/action';
import { AgreementActions } from 'agreement/types/redux/AgreementActions';
import AgreementsState from 'agreement/types/redux/AgreementsState';
import { AppState } from 'core/redux/rootReducer';
import { authSelectors } from 'tenantUser/redux/authReducer';
import { isString } from 'lodash';

const initState: AgreementsState = {
    agreements: {},
    selectedAgreement: null,
    list: [],
    map: {},
};

export const agreementsReducer = (state = initState, action: AgreementActions): AgreementsState => {
    switch (action.type) {
        case AGREEMENT.AGREEMENTS_FETCHED: {
            return {
                ...state,
                agreements: action.payload,
            };
        }
        case AGREEMENT.AGREEMENT_SELECTED: {
            return {
                ...state,
                selectedAgreement: action.payload,
            };
        }
        case AGREEMENT.DATA_UPDATED: {
            const { map, list } = action.payload;
            return {
                ...state,
                map,
                list,
            };
        }
        default:
            return state;
    }
};

const agreementsSelector = (state: AppState) => state.agreements;

const hasActiveAgreementsSelector = (state: AppState) =>
    agreementsSelector(state).list.some((agreement) => agreement.meta?.isActive);

const agreementCollectionSelector = (state: AppState) => Object.values(agreementsSelector(state).map);

const selectedAgreement = (state: AppState) => agreementsSelector(state).selectedAgreement;

const selectedAgreementId = (state: AppState): number | null => agreementsSelector(state).selectedAgreement?.id || null;

const isCurrentUserTenant = (state: AppState): boolean => {
    const agreement = selectedAgreement(state);
    if (!agreement) {
        return false;
    }

    const tenants = agreement.tenants;
    const user = authSelectors.user(state);

    if (!tenants || !user || isString(user) || !user.email) {
        return false;
    }

    return tenants.some((tenant) => user.email === tenant.email);
};

export const agreementSelectors = {
    hasActiveAgreementsSelector,
    agreementCollectionSelector,
    selectedAgreement,
    isCurrentUserTenant,
    selectedAgreementId,
};
